import { ProgressBarTheme } from '../types';
import { neutralColors } from '../constants/colors';

export const progressBar: ProgressBarTheme = {
  color: neutralColors.black,
};
